import React from 'react';

interface SelectUserAvatarProps {
  size?: number;
  className?: string;
}

export const SelectUserAvatar: React.FC<SelectUserAvatarProps> = ({
  size = 40,
  className = ''
}) => {
  const svg = `
    <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
      <circle cx="${size/2}" cy="${size/2}" r="${size/2}" fill="#e5e7eb"/>
      <g transform="translate(${size/2}, ${size/2})">
        <circle cx="0" cy="-${size/8}" r="${size/6}" fill="#9ca3af" stroke="none"/>
        <path d="M -${size/4} ${size/6} Q 0 ${size/12} ${size/4} ${size/6}" 
              fill="#9ca3af" stroke="none"/>
      </g>
    </svg>
  `;
  
  return (
    <img
      src={`data:image/svg+xml;base64,${btoa(svg)}`}
      alt="Select user"
      className={`rounded-full ${className}`}
      style={{ width: size, height: size }}
    />
  );
}; 